import * as request from "../lib/lib";


const baseUrl = process.env.REACT_APP_BACKEND_URL + 'Application';

export const getApplication = async (id, hashedParentEGN) => {
    const result = await request.get(`${baseUrl}/${id}`);

    return result;
}

export const getAllApplication = async (hashedParentEGN) => {
    const result = await request.get(`${baseUrl}/GetAllForParent?hpe=${hashedParentEGN}`);


    return result;
}

export const RegisterAddressReisdenceApplication = async (body) => {
    const result = await request.post(`${baseUrl}/AddressResidence`, body);

    return result;
}

export const RegisterAddressReisdenceApplicationPredefinedUsers = async (body) => {
    const result = await request.post(`${baseUrl}/AddressResidencePredefinedUsers`, body);

    return result;
}

export const editApplication = async (id, data) => {
    const result = await request.put(`${baseUrl}/AddressResidence/${id}`, data);

    return result;
}

export const createMunicipalityApplication = async (data) => {
    const result = await request.post(`${baseUrl}/Municipality`, data);

    return result;
}

export const editMunicipalityApplication = async (id, data) => {
    const result = await request.put(`${baseUrl}/Municipality/${id}`, data);

    return result;
}

export const createFreeAddressTextApplication = async (data) => {
    const result = await request.post(`${baseUrl}/AddressFreeText`, data);

    return result;
}

export const editFreeAddressTextApplication = async (id, data) => {
    const result = await request.put(`${baseUrl}/AddressFreeText/${id}`, data);

    return result;
}

export const createManualAddressApplication = async (data) => {
    const result = await request.post(`${baseUrl}/ManualAddress`, data);

    return result;
}

export const createManualAddressApplicationPredefinedUsers = async (data) => {
    const result = await request.post(`${baseUrl}/ManualAddressPredefinedUsers`, data);

    return result;
}

export const editManualApplication = async (id, data) => {
    const result = await request.put(`${baseUrl}/ManualAddress/${id}`, data);

    return result;
}

export const getAllApplicationHistory = async (id, hashedParentEGN) => {
    const result = await request.get(`${baseUrl}/RegNumberHistory/${id}`);

    return result;
}


export const cancellationApplication = async (id) => {
    const result = await request.putPdf(`${baseUrl}/Cancellation/${id}`);

    return result;
}

export const cancellationDeclaration = async (id) => {
    const result = await request.getGetPdf(`${baseUrl}/CancellationDeclaration/${id}`);

    return result;
}